import { KolIdentityType } from '@/types/api/search'
import { KolSchemaModel } from '@/types/schema/kol-schema'
import { KolInfo } from '@/types/schema/kol/kol-info-schema'
import convertKolInfoLinkToKolSchemaLink from '@/utils/kol/convert-kol-info-link-to-kol-schema-link'
import convertKpiToKpiSchema from '@/utils/kol/convert-kpi-to-kpi-schema'

/**
 * Convert KolInfo to KolSchemaModel
 * @param kolInfo - KolInfo from the API
 * @returns KolSchemaModel
 */
export const convertKolInfoToKolSchemaModel = (
  kolInfo: KolInfo,
): KolSchemaModel => {
  return {
    type: KolIdentityType.Person,
    id: kolInfo.id,
    name: kolInfo.name,
    subNames: kolInfo.sub_names,
    gender: kolInfo.gender,
    customizedTagsNames: kolInfo.customized_tags_names,
    description: kolInfo.description,
    customTag: kolInfo.custom_tag,
    verified: kolInfo.verified,
    isRadarStar: kolInfo.is_radar_star,
    visibility: kolInfo.visibility,
    links: kolInfo.links.map(convertKolInfoLinkToKolSchemaLink),
    follower: kolInfo.follower,
    kpi: kolInfo.kpi.map(convertKpiToKpiSchema),
    postCount: 0, // Only available in KolRadarSearch
    maxInteractiveRate3m: kolInfo.max_interactive_rate_3m,
    maxFansUpRate3m: kolInfo.max_fans_up_rate_3m,
    maxAvgPvRate3m: kolInfo.max_avg_pvRate_3m,
    crawledDescription: kolInfo.crawled_description,
    potential: kolInfo.potential,
    countryCode: kolInfo.country_code,
    recommend: '', // Only available in KolRadarSearch
    isCollectionKol: kolInfo.is_collection_kol,
    snapshotAt: kolInfo.snapshot_at,
    snapshotUpdatedAt: kolInfo.snapshot_updated_at,
    isUnlocked: null, // Not available in KolInfo api
    matchedPosts: [], // Only available in KolRadarSearch
    latestPosts: [], // Only available in KolRadarSearch
    withNewDataToUnlock: kolInfo.with_new_data_to_unlock,
    languages: kolInfo.languages,
    similarKolPlatform: null, // Only available in KolRadarSearch
    dcIdHashed: kolInfo.dc_id_hashed,
    isAddedToDirectory: kolInfo.is_added_to_directory,
    isExpired: kolInfo.is_expired,
  }
}
